import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment from 'moment';

@Component({
    selector: 'app-journal',
    templateUrl: './journal.component.html',
    styleUrls: ['./journal.component.css']
})
export class JournalComponent implements OnInit {
    currentPage = 1;
    pageSize = 20;
    recordCount = 0;
    totalPages = 0;
    constructor(private accService: AccountingService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }

    PagintInit() {
        this.currentPage = 1;
        this.pageSize = 20;
        this.recordCount = 0;
        this.totalPages = 0;
    }
    numberOfPages() {

        this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }

    nextPage() {
        this.currentPage = this.currentPage + 1;

    }

    pageSizes() {
        this.currentPage = 1;
        this.recordCount = 0;
        this.totalPages = 0;

    }
    keyval: any;
    getkeys(event) {
        this.keyval = event.keyCode;
        if (this.keyval == 13) {
            this.Add();
        }
    }










    ItemList = [];
    SubmittedAdd = false;
    Edit(item) {
        this.spinnerService.show();
        this.PaymentModel.TransID = item.TransID;
        this.PaymentModel.Remarks = item.Narration;
       
        this.PaymentModel.TransDate = moment(new Date(item.TransDate)).format("DD-MMM-YYYY");
        this.accService.GetJournalVoucherDetails(item.TransID).subscribe((response) => {
            this.ItemList = response.JournaVoucherDetailsList;
            this.SumTotalAmount();
            setTimeout(() => {
                this.spinnerService.hide();
                this.globalHelper.CheckActionStatus(response);

            }, 10);
        });

    }
    Add() {
        this.SubmittedAdd = true;
        if (!this.ValidateAdd()) {
            this.SubmittedAdd = false;
            var itembo = {
                AccName: this.PaymentModel.AccName,
                AccID: this.PaymentModel.AccID,
                DebitAmt: this.PaymentModel.DebitAmt,
                CreditAmt: this.PaymentModel.CreditAmt,
                Narration: this.PaymentModel.Narration
            }
            this.ItemList.push(itembo);
            this.SumTotalAmount();
            this.AccName = "";
            this.PaymentModel.DebitAmt = 0;
            this.PaymentModel.CreditAmt = 0;
            this.PaymentModel.Narration = '';
            this.AccCode = '';
            this.PaymentModel.DebitAccID = 0;
            this.PaymentModel.AccName = '';
            this.PaymentModel.AccID = 0;
        }
    }

    ValidateAdd() {
        return this.PaymentModel.AccID == 0;
    };
    Print = '';
    TransID = '0';
    Narration = "";
    GetVoucherPrint(item) {
        this.Print = 'P';
        this.TransID = item.TransID;
        this.Narration = item.Narration;
        var url = "journalvoucherprint?ReportType=PrintCashReceipt&TransID=" + this.TransID;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    }
    JournaVoucherDetailsList: any;
    tTotalDebitAmt = 0;
    TotalCreditAmt = 0;
    TotalDebitAmt = 0;
    Views = {
        TransDate:"",
        Cancel:"",
        CancelRemarks:"",
    }
    VoucherNo = "";
    TransType = "";
    GetVoucherDetails(item) {
        this.TotalDebitAmt = item.DebitAmt;
        this.TotalCreditAmt = item.CreditAmt;
        this.Views.TransDate = item.CreatedOn;
        this.Views.Cancel = item.Cancel;
        this.Views.CancelRemarks = item.CancelRemarks;
        this.TransID = item.TransID;
        this.VoucherNo = item.VoucherNo;
        this.TransType = item.TransType;
        this.spinnerService.show();
        this.accService.GetJournalVoucherDetails(this.TransID).subscribe((response) => {
            this.JournaVoucherDetailsList = response.JournaVoucherDetailsList;
            setTimeout(() => {
                this.spinnerService.hide();
                this.globalHelper.CheckActionStatus(response);
            }, 10);
        });
    }

    removeRow(index) {
        this.ItemList.splice(index, 1);
        this.SumTotalAmount();
    };

    SumTotalAmount() {
        this.PaymentModel.TotalDebitAmt = 0;
        this.PaymentModel.TotalCreditAmt = 0;
        var TotalDebitAmt = 0;
        var TotalCreditAmt = 0;
        for (var i = 0; i < this.ItemList.length; i++) {
            TotalDebitAmt = (TotalDebitAmt) + (this.ItemList[i].DebitAmt);
            TotalCreditAmt = (TotalCreditAmt) + (this.ItemList[i].CreditAmt);
        }
        this.PaymentModel.TotalDebitAmt = TotalDebitAmt;
        this.PaymentModel.TotalCreditAmt = TotalCreditAmt;
    }



    PaymentModel = {
        TransID: 0,
        TotalCreditAmt: 0,
        TotalDebitAmt: 0,
        AccID: 0,
        DebitAccID: 0,
        CreditAccID: 0,
        Amount: 0,
        AccName: '',
        DebitAmt: 0,
        CreditAmt: 0,
        Narration: '',
        ChequeDate: '',
        ChequeNo: '',
        TransDate: moment(new Date()).format("DD-MMM-YYYY"),
        Remarks: '',
    };

    onSelectCashSearch($item) {
        this.PaymentModelSearch.AccID = $item.ItemId;
    }
    AccName = "";
    loadingSave = false;
    Submitted = false;
    ClearAdd() {
        this.AccName = "";
        this.loadingSave = false;
        this.Submitted = false;
        this.ItemList = [];
        this.SubmittedAdd = false;
        this.PaymentModel = {
            TransID: 0,
            TotalCreditAmt: 0,
            TotalDebitAmt: 0,
            AccID: 0,
            DebitAccID: 0,
            CreditAccID: 0,
            Amount: 0,
            AccName: '',
            DebitAmt: 0,
            CreditAmt: 0,
            Narration: '',
            ChequeDate: '',
            ChequeNo: '',
            TransDate: moment(new Date()).format("DD-MMM-YYYY"),
            Remarks: '',
        };

    };
    SearchBankAccName = '';
    ClearSearch() {
        this.PaymentModelSearch.AccID = 0;
        this.PaymentModelSearch.FromDate = '';
        this.PaymentModelSearch.ToDate = '';
        this.PaymentModelSearch.Narration = '';
        this.SearchBankAccName = '';
    };

    PaymentModelSearch = {
        AccID: 0,
        FromDate: '',
        ToDate: '',
        Narration: '',
        CurrentIndex: 0,
        PageSize: 0
    };
    AccountList: any;
    GetAccount() {
        this.lookupService.GetLookupsList('Acc', '').subscribe((data) => {
            this.AccountList = data.LookupItems;
            this.AccountList.splice(0, 1);
        });
    }
      
    Clear() {
        this.PaymentModel.CreditAccID = 0;
        this.PaymentModel.Amount = 0;
        this.Submitted = false;
    };

    onSelect($item) {
        this.AccName = $item.AccName;
        this.PaymentModel.DebitAccID = $item.AccID;
    }
    AccCode = "";
    onSelectName($item) {
        this.AccCode = $item.AccCode;
        this.PaymentModel.DebitAccID = $item.AccID;
        this.PaymentModel.AccName = $item.AccName;
        this.PaymentModel.AccID = $item.AccID;
    }

    onSelectCash($item) {
        this.PaymentModel.CreditAccID = $item.AccID;
    }
    BankAccountList: any;
    GetBankAccount() {
        this.lookupService.GetLookupsList('BankAcc', '').subscribe((data) => {
            this.BankAccountList = data.LookupItems;
            this.BankAccountList.splice(0, 1);
        });
    }
    ChangeDebit() {
        this.PaymentModel.CreditAmt = 0;
    }
    ChangeCredit() {
        this.PaymentModel.DebitAmt = 0;
    }
    ValidateDropdownSave() {
        return this.PaymentModel.DebitAccID == 0 || this.PaymentModel.CreditAccID == 0 || this.PaymentModel.Amount == 0
    };


    SavePayment() {
        this.Submitted = true;
        if (this.ItemList.length > 0 && this.PaymentModel.TransDate != '') {
            if ((Math.round(this.PaymentModel.TotalDebitAmt * 1000) / 1000) == (Math.round(this.PaymentModel.TotalCreditAmt * 1000) / 1000)) {
                this.spinnerService.show();
                this.loadingSave = true;
                this.PaymentModel.TransDate = moment(this.PaymentModel.TransDate).format('DD-MMM-YYYY');
                this.accService.SaveJournal(JSON.stringify(this.ItemList), JSON.stringify(this.PaymentModel)).subscribe((response) => {
                    setTimeout(() => {
                        this.spinnerService.hide();
                        this.GetJournal();
                        this.AccName = "";
                        this.loadingSave = false;
                        this.Submitted = false;
                        if (response.webResponse.Status) {
                            this.ItemList = [];
                            this.PaymentModel = {
                                TransID: 0,
                                TotalCreditAmt: 0,
                                TotalDebitAmt: 0,
                                AccID: 0,
                                DebitAccID: 0,
                                CreditAccID: 0,
                                Amount: 0,
                                AccName: '',
                                DebitAmt: 0,
                                CreditAmt: 0,
                                Narration: '',
                                ChequeDate: '',
                                ChequeNo: '',
                                TransDate: moment(new Date()).format("DD-MMM-YYYY"),
                                Remarks: '',
                            };
                            this.Clear();
                        }
                    }, 10);
                    this.globalHelper.CheckActionStatus(response);
                });
            }
            else {
                alert('Debit and Credit Amount  not balance');
            }

        }
        else {
            if (this.ItemList.length > 0) {
                this.JAlert = "Please Add At list one item"
            }
            if (this.PaymentModel.TransDate == '') {
                this.JAlert = "Please Enter  Trans Date"
            }
        }
    }
    JAlert: any;
    loadingSearch = true;
    JournalList: any;
    GetJournal() {
        this.loadingSearch = true;
        this.PaymentModelSearch.CurrentIndex = this.currentPage;
        this.PaymentModelSearch.PageSize = this.pageSize;
        this.spinnerService.show();
        this.PaymentModelSearch.FromDate =this.PaymentModelSearch.FromDate!=null && this.PaymentModelSearch.FromDate!=''? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY'):'';
        this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate!=null && this.PaymentModelSearch.ToDate!=''?moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY'):'';
     
        this.accService.GetJournal(JSON.stringify(this.PaymentModelSearch)).subscribe((response) => {
            this.JournalList = response.JournalList;
            this.spinnerService.hide();
           
            setTimeout(() => {

                this.loadingSearch = false;
                this.globalHelper.CheckActionStatus(response);

            }, 10);

            this.recordCount = 0;
            if (response.JournalList != null && response.JournalList.length > 0) {
                this.recordCount = response.JournalList[0].RecordCount;

            }
            this.numberOfPages();

        });
    };
    TransDate:any;
    GetVoucherCancel  (item) {
        this.submitCancel = false;
       
        this.CancelModel.TransID = item.TransID;
      
        this.TransDate = item.CreatedOn;
        this.TransID = item.TransID;
        this.VoucherNo = item.VoucherNo;
        this.TransType = item.TransType;
      }
      loadingCancel = false;
      CancelModel = {
        CancelRemarks: '',
        TransID: 0,
      }
      submitCancel = false;
      CancelVoucher  () {
        this.submitCancel = true;
        if (this.CancelModel.CancelRemarks != '') {
      
            this.loadingCancel = true;
            this.submitCancel = false;
            this.accService.CancelVoucher(JSON.stringify(this.CancelModel)).subscribe((response) => {
                this.globalHelper.CheckActionStatus(response);
                this.GetJournal();
      
                if(response.webResponse.Status){
                    this.CancelModel = {
                        CancelRemarks: '',
                        TransID: 0,
                    }
                }
              
                this.loadingCancel = false;
                
            });
          
         
        }
      
      }


    ngOnInit() {
        setTimeout(() => {
     
            this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");
      
            this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");
            this.GetJournal();       
          }, 300);
        this.PagintInit();
        
        this.GetAccount();
        this.GetBankAccount();
    }

}
